import PropTypes from 'prop-types';
// @mui
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import TableCell from '@mui/material/TableCell';
import IconButton from '@mui/material/IconButton';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
// components
import Label from 'src/components/label';
import Iconify from 'src/components/iconify';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import { ConfirmDialog } from 'src/components/custom-dialog';
import { TestEmailModal } from './test-email-modal';
import { TestScheduleModal } from './test-schedule-modal ';
import { TestSendEmailModal } from './test-email-sent-modal';
import { useNavigate } from 'react-router';
//

// ----------------------------------------------------------------------

export default function UserTableRow({ row, selected, onEditRow, onSelectRow, onDeleteRow }) {
    const { status, subject, scheduled_date_time, scheduled_date, scheduled_time, created_at } = row;
    const navigate = useNavigate();

    const confirm = useBoolean();
    const add = useBoolean();
    const schdule = useBoolean();
    const email = useBoolean();
    const popover = usePopover();

    return (
        <>
            <TableRow hover selected={ selected }>
                <TableCell padding="checkbox">
                    <Checkbox checked={ selected } onClick={ onSelectRow } />
                </TableCell>
                <TableCell sx={ { whiteSpace: 'nowrap' } }>{ subject }</TableCell>
                <TableCell sx={ { whiteSpace: 'nowrap' } }>{ created_at }</TableCell>
                <TableCell sx={ { whiteSpace: 'nowrap' } }>{ scheduled_date }</TableCell>
                <TableCell sx={ { whiteSpace: 'nowrap' } }>{ scheduled_time }</TableCell>
                <TableCell>
                    <Label
                        variant="soft"
                        color={ status === 0 ? 'warning' : status === 1 ? 'success' : 'default' }
                    >
                        <Iconify
                            icon={ status === 0 ? "material-symbols:av-timer-rounded" : "material-symbols:done" }
                        />
                        { status === 0 ? 'Pending' : 'Sent' }
                    </Label>
                </TableCell>
                <TableCell align="right" sx={ { px: 1, whiteSpace: 'nowrap' } }>
                    {/* <Tooltip title="Quick Edit" placement="top" arrow>
                        <IconButton color={ quickEdit.value ? 'inherit' : 'default' } onClick={ quickEdit.onTrue }>
                            <Iconify icon="solar:pen-bold" />
                        </IconButton>
                    </Tooltip> */}
                    <IconButton color={ popover.open ? 'inherit' : 'default' } onClick={ () => add.onTrue() }>
                        <Iconify icon="material-symbols:share-reviews" />
                    </IconButton>
                    <IconButton color={ popover.open ? 'inherit' : 'default' } onClick={ () => schdule.onTrue() }>
                        <Iconify icon="material-symbols:nest-clock-farsight-analog-rounded" />
                    </IconButton>
                    <IconButton color={ popover.open ? 'inherit' : 'default' } onClick={ () => email.onTrue() }>
                        <Iconify icon="material-symbols:mark-email-unread-rounded" />
                    </IconButton>
                    <IconButton color={ popover.open ? 'inherit' : 'default' } onClick={ popover.onOpen }>
                        <Iconify icon="eva:more-vertical-fill" />
                    </IconButton>
                </TableCell>
            </TableRow>

            {/* //modals */ }
            <TestEmailModal
                row={ row }
                open={ add.value }
                onClose={ add.onFalse }
            />
            <TestScheduleModal
                row={ row }
                open={ schdule.value }
                onClose={ schdule.onFalse }
            />
            <TestSendEmailModal
                row={ row }
                open={ email.value }
                onClose={ email.onFalse }
            />


            <CustomPopover
                open={ popover.open }
                onClose={ popover.onClose }
                arrow="right-top"
                sx={ { width: 140 } }
            >
                <MenuItem
                    onClick={ () => {
                        confirm.onTrue();
                        popover.onClose();
                    } }
                    sx={ { color: 'error.main' } }
                >
                    <Iconify icon="solar:trash-bin-trash-bold" />
                    Delete
                </MenuItem>

                <MenuItem
                    onClick={ () => {
                        navigate("/dashboard/product-updates/blogs/create-blogs", { state: row });
                    } }
                >
                    <Iconify icon="solar:pen-bold" />
                    Edit
                </MenuItem>
            </CustomPopover>

            <ConfirmDialog
                open={ confirm.value }
                onClose={ confirm.onFalse }
                title="Delete"
                content="Are you sure want to delete?"
                action={
                    <Button variant="contained" color="error" onClick={ onDeleteRow }>
                        Delete
                    </Button>
                }
            />
        </>
    );
}

UserTableRow.propTypes = {
    onDeleteRow: PropTypes.func,
    onEditRow: PropTypes.func,
    onSelectRow: PropTypes.func,
    row: PropTypes.object,
    selected: PropTypes.bool,
};
